import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 24 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ index, label, testid }) => (
  <Reveal className="flex items-center gap-4 mb-10">
    <span className="font-mono text-[11px] tracking-[0.3em] text-gold">{index}</span>
    <span className="h-px w-10 bg-gold/60" />
    <span data-testid={testid} className="font-mono text-[11px] tracking-[0.3em] uppercase text-white/50">
      {label}
    </span>
  </Reveal>
);
